import React from "react";

function Welcome() {
  return (
    <div>
      <svg
        className="svg-image"
        width="708"
        height="122"
        viewBox="0 0 708 122"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_2_4)">
          <path
            d="M145.232 6.632L116.144 107H101.456L78.128 26.216L53.936 107L39.392 107.144L11.312 6.632H25.28L47.168 91.736L71.36 6.632H86.048L109.088 91.448L131.12 6.632H145.232Z"
            stroke="#64FFD3"
            stroke-width="10"
            shape-rendering="crispEdges"
            mask="url(#path-1-outside-1_2_4)"
          />
          <path
            d="M172.676 17.288V50.84H209.252V61.64H172.676V96.2H213.572V107H159.572V6.488H213.572V17.288H172.676Z"
            stroke="#64FFD3"
            stroke-width="10"
            shape-rendering="crispEdges"
            mask="url(#path-1-outside-1_2_4)"
          />
          <path
            d="M246.505 96.344H281.641V107H233.401V6.632H246.505V96.344Z"
            stroke="#64FFD3"
            stroke-width="10"
            shape-rendering="crispEdges"
            mask="url(#path-1-outside-1_2_4)"
          />
          <path
            d="M290.661 56.744C290.661 46.952 292.869 38.168 297.285 30.392C301.701 22.52 307.701 16.376 315.285 11.96C322.965 7.544 331.461 5.336 340.773 5.336C351.717 5.336 361.269 7.976 369.429 13.256C377.589 18.536 383.541 26.024 387.285 35.72H371.589C368.805 29.672 364.773 25.016 359.493 21.752C354.309 18.488 348.069 16.856 340.773 16.856C333.765 16.856 327.477 18.488 321.909 21.752C316.341 25.016 311.973 29.672 308.805 35.72C305.637 41.672 304.053 48.68 304.053 56.744C304.053 64.712 305.637 71.72 308.805 77.768C311.973 83.72 316.341 88.328 321.909 91.592C327.477 94.856 333.765 96.488 340.773 96.488C348.069 96.488 354.309 94.904 359.493 91.736C364.773 88.472 368.805 83.816 371.589 77.768H387.285C383.541 87.368 377.589 94.808 369.429 100.088C361.269 105.272 351.717 107.864 340.773 107.864C331.461 107.864 322.965 105.704 315.285 101.384C307.701 96.968 301.701 90.872 297.285 83.096C292.869 75.32 290.661 66.536 290.661 56.744Z"
            stroke="#64FFD3"
            stroke-width="10"
            shape-rendering="crispEdges"
            mask="url(#path-1-outside-1_2_4)"
          />
          <path
            d="M452.295 108.008C442.983 108.008 434.487 105.848 426.807 101.528C419.127 97.112 413.031 91.016 408.519 83.24C404.103 75.368 401.895 66.536 401.895 56.744C401.895 46.952 404.103 38.168 408.519 30.392C413.031 22.52 419.127 16.424 426.807 12.104C434.487 7.688 442.983 5.48 452.295 5.48C461.703 5.48 470.247 7.688 477.927 12.104C485.607 16.424 491.655 22.472 496.071 30.248C500.487 38.024 502.695 46.856 502.695 56.744C502.695 66.632 500.487 75.464 496.071 83.24C491.655 91.016 485.607 97.112 477.927 101.528C470.247 105.848 461.703 108.008 452.295 108.008ZM452.295 96.632C459.303 96.632 465.591 95 471.159 91.736C476.823 88.472 481.239 83.816 484.407 77.768C487.671 71.72 489.303 64.712 489.303 56.744C489.303 48.68 487.671 41.672 484.407 35.72C481.239 29.672 476.871 25.016 471.303 21.752C465.735 18.488 459.399 16.856 452.295 16.856C445.191 16.856 438.855 18.488 433.287 21.752C427.719 25.016 423.303 29.672 420.039 35.72C416.871 41.672 415.287 48.68 415.287 56.744C415.287 64.712 416.871 71.72 420.039 77.768C423.303 83.816 427.719 88.472 433.287 91.736C438.951 95 445.287 96.632 452.295 96.632Z"
            stroke="#64FFD3"
            stroke-width="10"
            shape-rendering="crispEdges"
            mask="url(#path-1-outside-1_2_4)"
          />
          <path
            d="M621.802 7.352V107H608.698V32.696L575.578 107H566.362L533.098 32.552V107H519.994V7.352H534.106L570.97 89.72L607.834 7.352H621.802Z"
            stroke="#64FFD3"
            stroke-width="10"
            shape-rendering="crispEdges"
            mask="url(#path-1-outside-1_2_4)"
          />
          <path
            d="M657.13 17.288V50.84H693.706V61.64H657.13V96.2H698.026V107H644.026V6.488H698.026V17.288H657.13Z"
            stroke="#64FFD3"
            stroke-width="10"
            shape-rendering="crispEdges"
            mask="url(#path-1-outside-1_2_4)"
          />
        </g>
        <mask
            id="path-1-outside-1_2_4"
            maskUnits="userSpaceOnUse"
            x="4.31201"
            y="0.335999"
            width="699"
            height="113"
            fill="black"
          >
            <rect
              fill="white"
              x="4.31201"
              y="0.335999"
              width="699"
              height="113"
            />
            <path d="M145.232 6.632L116.144 107H101.456L78.128 26.216L53.936 107L39.392 107.144L11.312 6.632H25.28L47.168 91.736L71.36 6.632H86.048L109.088 91.448L131.12 6.632H145.232Z" />
            <path d="M172.676 17.288V50.84H209.252V61.64H172.676V96.2H213.572V107H159.572V6.488H213.572V17.288H172.676Z" />
            <path d="M246.505 96.344H281.641V107H233.401V6.632H246.505V96.344Z" />
            <path d="M290.661 56.744C290.661 46.952 292.869 38.168 297.285 30.392C301.701 22.52 307.701 16.376 315.285 11.96C322.965 7.544 331.461 5.336 340.773 5.336C351.717 5.336 361.269 7.976 369.429 13.256C377.589 18.536 383.541 26.024 387.285 35.72H371.589C368.805 29.672 364.773 25.016 359.493 21.752C354.309 18.488 348.069 16.856 340.773 16.856C333.765 16.856 327.477 18.488 321.909 21.752C316.341 25.016 311.973 29.672 308.805 35.72C305.637 41.672 304.053 48.68 304.053 56.744C304.053 64.712 305.637 71.72 308.805 77.768C311.973 83.72 316.341 88.328 321.909 91.592C327.477 94.856 333.765 96.488 340.773 96.488C348.069 96.488 354.309 94.904 359.493 91.736C364.773 88.472 368.805 83.816 371.589 77.768H387.285C383.541 87.368 377.589 94.808 369.429 100.088C361.269 105.272 351.717 107.864 340.773 107.864C331.461 107.864 322.965 105.704 315.285 101.384C307.701 96.968 301.701 90.872 297.285 83.096C292.869 75.32 290.661 66.536 290.661 56.744Z" />
            <path d="M452.295 108.008C442.983 108.008 434.487 105.848 426.807 101.528C419.127 97.112 413.031 91.016 408.519 83.24C404.103 75.368 401.895 66.536 401.895 56.744C401.895 46.952 404.103 38.168 408.519 30.392C413.031 22.52 419.127 16.424 426.807 12.104C434.487 7.688 442.983 5.48 452.295 5.48C461.703 5.48 470.247 7.688 477.927 12.104C485.607 16.424 491.655 22.472 496.071 30.248C500.487 38.024 502.695 46.856 502.695 56.744C502.695 66.632 500.487 75.464 496.071 83.24C491.655 91.016 485.607 97.112 477.927 101.528C470.247 105.848 461.703 108.008 452.295 108.008ZM452.295 96.632C459.303 96.632 465.591 95 471.159 91.736C476.823 88.472 481.239 83.816 484.407 77.768C487.671 71.72 489.303 64.712 489.303 56.744C489.303 48.68 487.671 41.672 484.407 35.72C481.239 29.672 476.871 25.016 471.303 21.752C465.735 18.488 459.399 16.856 452.295 16.856C445.191 16.856 438.855 18.488 433.287 21.752C427.719 25.016 423.303 29.672 420.039 35.72C416.871 41.672 415.287 48.68 415.287 56.744C415.287 64.712 416.871 71.72 420.039 77.768C423.303 83.816 427.719 88.472 433.287 91.736C438.951 95 445.287 96.632 452.295 96.632Z" />
            <path d="M621.802 7.352V107H608.698V32.696L575.578 107H566.362L533.098 32.552V107H519.994V7.352H534.106L570.97 89.72L607.834 7.352H621.802Z" />
            <path d="M657.13 17.288V50.84H693.706V61.64H657.13V96.2H698.026V107H644.026V6.488H698.026V17.288H657.13Z" />
          </mask>
        <defs>
          <filter
            id="filter0_d_2_4"
            x="0.723724"
            y="0.335999"
            width="706.302"
            height="120.672"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2_4"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2_4"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
}

export default Welcome;
